module.exports = __webpack_public_path__ + "img/3.879c625d.jpg";